var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.fileReady)?_c('embeder',{attrs:{"fileId":_vm.file.id,"minusHeight":_vm.minusHeight}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }